import { createFileRoute } from '@tanstack/react-router';
import { NotificationDetail } from '@/features/notifications/NotificationDetail';

/** La singola notifica: il testo intero, e il collegamento alla sezione quando esiste. */
export const Route = createFileRoute('/_app/notifications/$notificationId')({ component: Page });

function Page() {
  const { notificationId } = Route.useParams();
  return <NotificationDetail notificationId={notificationId} />;
}
